import { render } from "./DefaultHome.vue?vue&type=template&id=1611e539"
import script from "./DefaultHome.vue?vue&type=script&lang=js"
export * from "./DefaultHome.vue?vue&type=script&lang=js"

import exportComponent from "E:\\dipto_projects\\parcel\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__